import { useEffect } from "react";
import { themeStore } from "stores/themeStore.store";
import { applyThemeVariables } from "configs/themeTokens";

/** Keeps CSS variables + Tailwind dark class in sync with Zustand theme. */
export default function ThemeSync() {
  const { currentTheme } = themeStore();

  useEffect(() => {
    applyThemeVariables(currentTheme || "light");
    document.body.classList.toggle("app-dark", currentTheme === "dark");
  }, [currentTheme]);

  return null;
}
